import React, { useMemo } from 'react';
import { Input, Button, Select, DatePicker } from 'components';
import moment from 'moment';
import { CloseIcon } from 'assets/icons';
import { Constants, Globals } from "utils";
import { UserService } from 'services';
import { FileIcon, PDFIcon } from 'assets/icons';

interface Props {
	item?: any;
	onClose: () => void;
	onSuccess: () => void;
	name?: string;
}

interface IState {
	form: {
		payment_method_id: number | string
		bank_id: number | string
		payment_date: Date | string
		payment_document: string
		payment_phone: string
		reference: string
		payment_photo?: File
	}
	conversion: number;
	banks: any[];
	payment_methods: any[];
}

class ModalCreate extends React.Component<Props, IState> {

	state = {
		form: {
			payment_method_id: Constants.PAYMENT_METHODS.MOVIL,
			bank_id: '',
			payment_date: '',
			payment_document: '',
			payment_phone: '',
			payment_name: '',
			payment_email: '',
			reference: '',
			payment_photo: undefined,
		},
		conversion: 0,
		banks: [],
		payment_methods: [],
	}

	componentDidMount() {
		this.getSelects();
	}

	getSelects = () => {
		Promise.all([
			UserService.admin.getBanks(),
			UserService.admin.getSelects({ without_cash: true }),
		]).then(res => {
			const banks = (res[0] as any)?.banks ?? [];
			const payment_methods = (res[1] as any)?.paymentMethods ?? [];
			const conversion = (res[1] as any)?.conversion ?? 0;
			this.setState({ banks, payment_methods, conversion });
		})
		.catch(console.log);
	}

	change = async (e: any) => {
		const { name, value } = e.target ?? e.currentTarget;
		await this.setState(s => ({
			form: { ...s.form, [name]: value }
		}));
	}

	isValidForm = () => {
		const onError = (msg: string) => {
			Globals.showError(msg);
			return false;
		}

		const { form } = this.state;

		if (!form.payment_method_id)
			return onError('Debe seleccionar un método de pago');

		if (Number(form.payment_method_id) === Constants.PAYMENT_METHODS.MOVIL) {
			if (!form.bank_id) return onError('Debe seleccionar un banco');
			if (!form.payment_document) return onError('Debe indicar la cédula de identidad');
			if (!form.payment_phone) return onError('Debe indicar el teléfono');

		} else if (Number(form.payment_method_id) === Constants.PAYMENT_METHODS.ZELLE) {
			if (!form.payment_name) return onError('Debe indicar el nombre del titular');
			if (!form.payment_email) return onError('Debe indicar el correo electrónico');

		} else {
			return onError('Debe seleccionar un método de pago válido');
		}

		if (!form.payment_date)
			return onError('Debe seleccionar una fecha');

		if (!form.reference)
			return onError('Debe indicar la referencia');

		return true;
	}

	parseOutput = () => {
		const { conversion, form } = this.state;

		// Establece los datos comunes entre los métodos de pago
		const payload: any = {
			id: this.props.item.id,
			payment_method_id: Number(form.payment_method_id),
			payment_date: form.payment_date,
			reference: form.reference,
			payment_photo: this.state.form.payment_photo,
			hasFile: !!this.state.form.payment_photo,
		};

		// Establece solo los campos necesarios para el método de pago seleccionado
		if (Number(payload.payment_method_id) === Constants.PAYMENT_METHODS.MOVIL) {
			payload.bank_id = form.bank_id;
			payload.payment_phone = form.payment_phone;
			payload.payment_document = form.payment_document;
			payload.amount_bs = this.props.item.amount * conversion;

		} else if (Number(payload.payment_method_id) === Constants.PAYMENT_METHODS.ZELLE) {
			payload.payment_email = form.payment_name;
			payload.payment_name = form.payment_email;
		}

		return payload;
	}

	submit = async (e: any) => {
		e.preventDefault();

		try {
			const payload = this.parseOutput();
			await UserService.admin.createCommissionPayment(payload);
			Globals.showSuccess('Pago registrado exitosamente');
			this.props.onSuccess();

		} catch (error) {
			console.log(error)
		}
	}

	render() {

		const { form } = this.state;
		const { item } = this.props;

		return (
			<div id="modal-create-doctor" className="create-commission-payment">
				<div className="header">
					<p className="title">Agregar Pago de Comisión</p>
					<button className="close" onClick={this.props.onClose}>
						<img src={CloseIcon} alt="Cerrar" />
					</button>
				</div>

				<div className="bank-info">
					<p><strong>{this.props.name}</strong></p>
					<p><strong>{ item?.user?.name }</strong></p>
					<div className="totals">
						<span>Comisión por pagar</span>
						<span>{ Globals.formatMiles(item?.amount) }</span>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<hr />
					</div>
				</div>

				{Number(form.payment_method_id) === Constants.PAYMENT_METHODS.MOVIL && (
					<div className="bank-info">
						<p><strong>Datos del pago</strong></p>
						<label><strong>Banco</strong>: { item?.user?.bank_account?.bank?.code } - { item?.user?.bank_account?.bank?.name }</label>
						<label><strong>N° de cuenta</strong>: { item?.user?.bank_account?.number }</label>
						<label><strong>C.I.</strong>: { item?.user?.bank_account?.document_format }</label>
						<label><strong>Teléfono</strong>: { item?.user?.bank_account?.phone_format }</label>
					</div>
				)}

				{Number(form.payment_method_id) === Constants.PAYMENT_METHODS.ZELLE && (
					<div className="bank-info">
						<p><strong>Datos del pago</strong></p>
						<label><strong>Banco</strong>: 0105 - Mercantil</label>
						<label><strong>N° de cuenta</strong>: 11112222333344445555</label>
						<label><strong>C.I.</strong>: 16332854</label>
						<label><strong>Teléfono</strong>: 04143214566</label>
					</div>
				)}

				<div className="row">
					<div className="col-md-12">
						<hr />
					</div>
				</div>

				<form className="row" onSubmit={ this.submit }>
					{/* <div className="col-md-12">
						<Select
							label="Método de pago"
							name="payment_method_id"
							onChange={this.change}
							value={form.payment_method_id}
							options={this.state.payment_methods.map((i: any) => ({ value: i.id, label: i.name }))}
						/>
					</div> */}

					{Number(form.payment_method_id) === Constants.PAYMENT_METHODS.MOVIL && (
						<>
							<div className="col-md-12">
								<Select
									label="Banco"
									name="bank_id"
									onChange={this.change}
									value={form.bank_id}
									options={this.state.banks.map((i: any) => ({ value: i.id, label: `${i.code} - ${i.name}` }))}
								/>
							</div>
							<div className="col-md-6">
								<Input
									color="white"
									label="Cédula"
									name="payment_document"
									value={form.payment_document}
									onChange={this.change}
								/>
							</div>
							<div className="col-md-6">
								<Input
									color="white"
									label="Teléfono"
									name="payment_phone"
									value={form.payment_phone}
									onChange={this.change}
								/>
							</div>
						</>
					)}

					{Number(form.payment_method_id) === Constants.PAYMENT_METHODS.ZELLE && (
						<>
							<div className="col-md-6">
								<Input
									color="white"
									label="Nombre del titular"
									name="payment_name"
									value={form.payment_name}
									onChange={this.change}
								/>
							</div>
							<div className="col-md-6">
								<Input
									color="white"
									label="Correo"
									name="payment_email"
									value={form.payment_email}
									onChange={this.change}
								/>
							</div>
						</>
					)}

					<div className="col-md-6">
						<DatePicker
							label="Fecha"
							dateFormat="dd-MM-yyyy"
							onChange={(value: any) => this.change({
								target: {
									value: moment(value).format('YYYY-MM-DD'),
									name: 'payment_date'
								}
							})}
							value={form.payment_date ? moment(form.payment_date, 'YYYY-MM-DD').toDate() : null}
						/>
					</div>

					<div className="col-md-6">
						<Input
							color="white"
							label="Referencia"
							name="reference"
							value={form.reference}
							onChange={this.change}
						/>
					</div>

					{/* <div className="col-md-12">
						<DocBox
							label="Comprobante (Opcional)"
							file={form.payment_photo}
							onChange={e => {
								if (e.target.files?.length) {
									const file = e?.target?.files[0];
									this.setState(s => ({ form: { ...s.form, payment_photo: file || undefined } }));
									e.target.value = '';
								}
							}}
						/>
					</div> */}

					<div className="col-md-12">
						<hr />
					</div>

					<div className="actions">
						<div>
							<Button type="submit">Guardar</Button>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

interface DocBoxProps {
  label: string;
  file?: File;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DocBox = ({ label, file, onChange }: DocBoxProps) => {
	const { fileName, isPDF, photo } = useMemo(() => {
		const isPDF = String(file?.type).endsWith('pdf');
		let photo = '';
		let fileName = '';

		if (!!file) {
			fileName = file.name;

			if (!isPDF) {
				photo = URL.createObjectURL(file);
			}
		}

		return { fileName, isPDF, photo };
	}, [file]);

  return (
    <label className="doc-box-wrapper">
      <label>{ label }</label>
      <div className="doc-box">
        {!!file && !isPDF && (
          <img className="document" src={photo} alt="Documento" />
        )}
        {!!file && isPDF && (
          <img className="document pdf" src={PDFIcon} alt="Documento" />
        )}
        {!file && (
          <img className="document empty" src={FileIcon} alt="Documento" />
        )}
        <p>{ fileName || 'Seleccione un archivo' }</p>
      </div>
      {onChange && (
        <input type="file" name="payment_photo" accept="image/*, application/pdf" hidden onChange={onChange} />
      )}
    </label>
  )
}

export default ModalCreate;

// v0